{
  "AgentAdvanced_Fields_LicenceType": "Callcenter Licentie Type:",
  "AgentAdvanced_Fields_InternalNumber": "Intern nummer:",
  "AgentAdvanced_Fields_CiscoCommonID": "Cisco gemeenschappelijke identiteit:",
  "AgentAdvanced_Fields_OverrideMonitoring": "Override bewaking:",
  "AgentAdvanced_Fields_WebexCallingUserID": "Webex Calling Gebruikers-ID:",
  "AgentAdvanced_Fields_BroadworksUserID": "BroadWorks gebruikers-ID:",
  "AgentAdvanced_Fields_TeamsUserID": "MS Teams Gebruikers-ID:",
  "AgentAdvanced_Fields_UserPrincipalName": "Voornaam gebruiker (URN):",
  "AgentAdvanced_Fields_OwningGroupID": "Groep ID:",
  "AgentAdvanced_Fields_OIDOnTelephoneServer": "OID op telefoonserver:",
  "AgentAdvanced_Fields_OwningDepartment": "Afdeling eigenaar (volledig pad):",
  "CallCentreLicenceTypes_None": "[Geen]",
  "CallCentreLicenceTypes_Basic": "Basis",
  "CallCentreLicenceTypes_Standard": "Standaard",
  "CallCentreLicenceTypes_Premium": "Premium",
  "NAME": "AgentAdvanced"
}